import { render, staticRenderFns } from "./CalendarDelete.vue?vue&type=template&id=10bb6d34&"
import script from "./CalendarDelete.vue?vue&type=script&lang=js&"
export * from "./CalendarDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports